import { computed, ref, watch } from 'vue';

import { useStore } from './store.composable';

import { LANG_DIRECTION } from '../models/constants';

export const useDirection = () => {
  const { state } = useStore();

  const dir = ref('');

  const isRTL = computed((): boolean => {
    if (dir.value === LANG_DIRECTION.RTL) return true;
    return false;
  });

  const getDirection = (): string => {
    const pageDir = document.querySelector('html')?.getAttribute('dir');
    return state.configuration.direction ?? pageDir ?? 'ltr';
  };

  dir.value = getDirection();

  watch(
    () => state.configuration.direction,
    (value) => {
      dir.value = value;
    }
  );

  return {
    dir,
    isRTL,
  };
};
